// extracted by mini-css-extract-plugin
export var backdropBlur = "_lx-0";
export var contentCard = "_lx-5";
export var frame = "_lx-2";
export var image = "_lx-4";
export var imagePane = "_lx-3";
export var modal = "_lx-1";